import { FlightFareSources } from '../constants';

const checkIsNdcFare = (flightItinerary, fareIndex = undefined) => {
  if (!flightItinerary) return false;
  const { flightSegments } = flightItinerary;
  if (!flightSegments || flightSegments.length === 0) return false;
  const { flights } = flightSegments[0];
  if (!flights || flights.length === 0) return false;
  if (fareIndex >= 0) {
    const fare = flights[0].allFares[fareIndex];
    if (fare) {
      return fare.pricingSubsource === FlightFareSources.NDC;
    }
  }
  const { selectedFare } = flights[0];
  if (!selectedFare) return false;
  return selectedFare.pricingSubsource === FlightFareSources.NDC;
};

export default checkIsNdcFare;
